import React, { createContext, useContext, useState, useEffect } from 'react';
import { fetchSites } from '../services/api';
import { useAuth } from './AuthContext';

const SitesContext = createContext();

export const useSites = () => {
  const context = useContext(SitesContext);
  if (!context) {
    throw new Error('useSites must be used within SitesProvider');
  }
  return context;
};

export const SitesProvider = ({ children }) => {
  const { authData } = useAuth();
  const [sites, setSites] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadSites = async () => {
    try {
      setLoading(true);
      setError(null);
      // If user is authenticated and has siteIds, pass them to filter sites
      const siteIds = authData?.siteIds;
      const sitesData = await fetchSites(siteIds);
      setSites(sitesData);
    } catch (err) {
      setError('Failed to load sites');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Load sites when authData changes (login/logout) or on startup
    loadSites();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authData?.siteIds]); // Reload when siteIds change

  return (
    <SitesContext.Provider value={{ sites, loading, error, refreshSites: loadSites }}>
      {children}
    </SitesContext.Provider>
  );
};

